import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Root, SplashScreen } from '@piwikpro/ui-components';

export const Route = createFileRoute('/_secured/$')({
  component: () => <Root withThemes><SplashScreen type="notFound" /></Root>,
});
